import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Flex, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	featureRow: {
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
	},
	disclaimer: {
		paddingTop: token('space.300'),
	},
});

export type Highlight = {
	icon: React.ComponentType<any>;
	title: string;
};

export const EditionHighlightsLeftContent = ({
	disclaimerText,
	highlights,
}: {
	disclaimerText?: string | React.ReactNode;
	highlights: Highlight[];
}) => {
	return (
		<Stack>
			<Flex direction="column">
				{highlights?.map((highlight) => {
					const { title, icon: IconComponent } = highlight;
					return (
						<Flex gap="space.150" alignItems="center">
							<IconComponent color={token('color.icon.brand')} label="" />
							<Box xcss={styles.featureRow}>
								<Text color="color.text.subtle">{title}</Text>
							</Box>
						</Flex>
					);
				})}
			</Flex>
			{disclaimerText && (
				<Box xcss={styles.disclaimer}>
					<Text color="color.text.subtlest" size="small">
						{disclaimerText}
					</Text>
				</Box>
			)}
		</Stack>
	);
};
